import * as React from "react";

import * as constants from "@client/constants";
import * as router from "@client/router";

export const StoreUpdateRequired = router.StoreUpdateRequired.withHooks(() => ({}))
    .withIndex(() => (
        <div
            className="
                flex h-full flex-col items-center justify-center gap-4 space-y-[8dvh]
                text-center text-4xl text-pretty
            "
        >
            <p>You’re using an outdated version of Joy.</p>
            <p>Please visit the app store and update the app.</p>
        </div>
    ))
    .withActions((props) => {
        if (props.platform == "android") {
            return [
                {
                    onClick: () => {
                        window.open(constants.PLAY_STORE_URL, "_blank");
                    },
                    icon: "custom-play-store",
                    title: "Open Play Store",
                },
            ];
        } else if (props.platform == "ios") {
            return [
                {
                    onClick: () => {
                        window.open(constants.APP_STORE_URL, "_blank");
                    },
                    icon: "custom-app-store",
                    title: "Open App Store",
                },
            ];
        } else {
            return [];
        }
    })
    .withOptions(() => ({title: "Update Required", scene: {kind: "SIMPLE"}}));
